import React from 'react';
import { DialogActionButton } from '@/components/common/CustomDialog';
import useFormValues from '@/lib/hooks/useFormValues';
import translate from '@/lib/intl/translate';
import CsvExportApiFields from '../constants/CsvExportApiFields';
import type CsvExportFormValues from '../types/CsvExportFormValues';

const API_FIELD_LOOKUP = CsvExportApiFields.reduce(
  (memo, field) => ({
    ...memo,
    [field]: true,
  }),
  {},
);

/**
 * The purpose of this component is the isolate the updates that come
 * from using useFormValues. That will cause a lot of re-renders so
 * keeping it local to the UI that needs it makes sense.
 */
export default function ExportSaveButton({
  isSubmitting,
}: {
  isSubmitting: boolean;
}) {
  const values = useFormValues<CsvExportFormValues>();

  const isDisabled = React.useMemo(() => {
    const keys = Object.keys(values) as (keyof CsvExportFormValues)[];

    return keys
      .filter((key) => key in API_FIELD_LOOKUP)
      .every((key) => !values[key]);
  }, [values]);

  return (
    <DialogActionButton
      disabled={isDisabled}
      showLoader={isSubmitting}
      type="submit"
      form="constituent-export-csv-dialog-form"
    >
      {translate('EXPORT')}
    </DialogActionButton>
  );
}
